import {
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  RssSimple,
  YoutubeLogo,
} from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";
import type { ISocialLink } from "@/lib/constants/social";

export const SOCIAL_ICONS: Record<ISocialLink["id"], Icon> = {
  instagram: InstagramLogo,
  facebook: FacebookLogo,
  linkedin: LinkedinLogo,
  youtube: YoutubeLogo,
  // x: XLogo,
};

export const RSS_ICON = RssSimple;
